import { useState, useEffect } from 'react';

// Custom hook to fetch and manage lake temperature data
const useLakeTemperatures = () => {
  // State to store temperature data
  const [temperatureData, setTemperatureData] = useState([]);
  // State to manage loading status
  const [loading, setLoading] = useState(true);
  // State to manage any errors
  const [error, setError] = useState(null);

  useEffect(() => {
    // Function to fetch temperature data from the API
    const fetchTemperatureData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Fetch data from the API
        const response = await fetch('https://aquaorca.etter.work/api/getCurrentData.php', {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        });

        // Throw an error if the response is not ok
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Parse the JSON data
        const data = await response.json();
        
        // Transform the API data to match our component structure
        const transformedData = data.map((item, index) => ({
          id: `${item.water_body}-${item.location}-${index}`,
          name: item.water_body,
          location: item.location,
          temperature: item.temperature ? parseFloat(item.temperature) : null,
          timestamp: item.timestamp,
          lastUpdate: new Date(item.timestamp).toLocaleString('de-CH')
        }));

        // Update the state with the transformed data
        setTemperatureData(transformedData);
      } catch (err) {
        // Log and set error state if there is an error
        console.error('Error fetching temperature data:', err);
        setError(err);
      } finally {
        // Set loading to false as data fetching is complete
        setLoading(false);
      }
    };

    // Call the function to fetch temperature data
    fetchTemperatureData();
    
    // Refresh data every 5 minutes
    const interval = setInterval(fetchTemperatureData, 5 * 60 * 1000);
    
    // Cleanup function
    return () => clearInterval(interval);
  }, []);

  // Return the state variables
  return { temperatureData, loading, error };
};

export default useLakeTemperatures;